import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import {
  IconeContainer,
  IconeContainerAtencao,
  InfoContainer,
  TextContainer,
} from "./style";
import { FaExclamation, FaRedo, FaTimes } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onClickOk: () => void;
  onClickReprocessar: () => void;
  mensagemErro: string | null;
  onClickOkReprocessarDanfe: () => void;
  idProcesso?: number;
}

export function ModalGerarProcessoManualmenteOuAutomaticamente({
  show,
  handleClose,
  onClickOk,
  onClickReprocessar,
  mensagemErro,
  onClickOkReprocessarDanfe,
  idProcesso,
}: Props) {
  const errosDanfe = [
    "O link do XML não foi encontrado",
    "Não foi possível recuperar a imagem a partir do link salvo.",
    "Erro ao gerar Danfe a partir do XML.",
  ];

  const verificarErroDanfe = () => {
    if (!mensagemErro) {
      return false;
    }

    if (errosDanfe.some((erro) => erro.includes(mensagemErro))) {
      return true;
    }

    return false;
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={`${
        mensagemErro && mensagemErro === "Escolha como gerar processo"
          ? ""
          : "Erro - "
      }Gerar processo`}
      centered
      adaptive
    >
      <InfoContainer>
        {mensagemErro && mensagemErro === "Escolha como gerar processo" ? (
          <IconeContainerAtencao>
            <FaExclamation />
          </IconeContainerAtencao>
        ) : (
          <IconeContainer>
            <FaTimes />
          </IconeContainer>
        )}
        <TextContainer>
          {!!idProcesso && (
            <span
              style={{ display: "block", fontWeight: 600, marginBottom: 4 }}
            >
              ID Processo: {idProcesso}
            </span>
          )}
          {mensagemErro ?? "Erro ao gerar processo."}
        </TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "14rem" }}
          outline
          variante="primary"
          onClick={onClickOk}
          hidden={verificarErroDanfe()}
        >
          Prosseguir manualmente
        </PrimaryButton>
        <PrimaryButton
          style={{ width: "10rem" }}
          onClick={
            verificarErroDanfe()
              ? onClickOkReprocessarDanfe
              : onClickReprocessar
          }
        >
          {mensagemErro && mensagemErro === "Escolha como gerar processo" ? (
            <>Processar</>
          ) : (
            <>
              Reprocessar <FaRedo />
            </>
          )}
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
